$(function () {
    (new Navigation("detailsNavigation")).init();
});

class Navigation {
    constructor(wrapperId) {
        this.init = this.init.bind(this);
        this._migrateAndGetFromSessionStorage = this._migrateAndGetFromSessionStorage.bind(this);
        this._getQueryParams = this._getQueryParams.bind(this);

        this.wrapper = document.getElementById(wrapperId);
    }

    init() {
        const element = $("li:first>a", this.wrapper);
        if (element.length === 0) return;

        const networkId = this.wrapper.getAttribute("data-network-id");
        if (!networkId) return;

        const lastSearchEncoded = this._migrateAndGetFromSessionStorage(networkId);
        if (lastSearchEncoded === null || lastSearchEncoded.trim().length < 1 || lastSearchEncoded == "null") {
            element.text(element.data("show-more-title"))
                .attr("data-webm-clickvalue", "show-more-like-this");
            return;
        }

        const searchResultsUrl = element.data("search-results-base-url");
        const lastSearch = decodeURIComponent(lastSearchEncoded);
        element
            .attr("href", searchResultsUrl + "?" + lastSearch)
            .text(element.data("back-to-search-title"))
            .attr("data-webm-clickvalue", "back-to-search");
    }

    _migrateAndGetFromSessionStorage(key) {
        let lsValue = localStorage.getItem(key);
        if (lsValue !== null && lsValue !== "" && lsValue !== "null") {
            sessionStorage.setItem(key, lsValue);
            localStorage.removeItem(key);
            return lsValue;
        }

        // Get from session storage
        lsValue = sessionStorage.getItem(key);
        if (lsValue !== null && lsValue !== "" && lsValue !== "null") {
            return lsValue;
        }

        // fall back to last-search-encoded key
        lsValue = localStorage.getItem("last-search-encoded");
        if (lsValue !== null && lsValue !== "" && lsValue !== "null") {
            sessionStorage.setItem(key, lsValue);
            localStorage.removeItem("last-search-encoded");
            return lsValue;
        }

        // fall back to query string
        lsValue = this._getParameterValueByName("psq");
        if (lsValue !== null && lsValue !== "" && lsValue !== "null") {
            const q = this._getQueryParams("psq", "q");
            const sort = this._getQueryParams("pss", "sort");
            const offset = this._getQueryParams("pso", "offset");
            const searchQuery = [q, sort, offset].filter(item => item !== null).join("&");

            sessionStorage.setItem(key, searchQuery);
            return searchQuery;
        }

        return sessionStorage.getItem(key);
    }

    _getQueryParams(paramName, queryName) {
        const paramValue = this._getParameterValueByName(paramName);
        if (paramValue !== null || paramValue !== "") {
            return encodeURIComponent(queryName + "=" + paramValue);
        }
        return null;
    }

    _getParameterValueByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
        const results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return results[2].replace(/\+/g, " ");
    }
}